import { type HTMLAttributes, type PropsWithChildren, forwardRef } from 'react'
import { Container } from '#app/ui/components/layout/container'
import { cn } from '#app/utils/tailwind-merge.ts'

type SectionProps = PropsWithChildren<HTMLAttributes<HTMLElement>> & {
	/**
	 * `plain` sits directly on the page background.
	 * `panel` is an inset rounded panel that inverts to a dark context — the
	 * `dark` class flips every semantic token inside it.
	 */
	tone?: 'plain' | 'panel'
}

/**
 * A page section. Panels are inset from the viewport edge and rounded, so the
 * page background stays visible around them.
 */
const Section = forwardRef<HTMLElement, SectionProps>(
	({ tone = 'plain', className, children, ...props }, ref) => {
		if (tone === 'panel') {
			return (
				<section ref={ref} className={cn('px-4', className)} {...props}>
					<div className="dark overflow-hidden rounded-3xl bg-panel py-fluid-17 text-foreground">
						<Container>{children}</Container>
					</div>
				</section>
			)
		}
		return (
			<section ref={ref} className={cn('py-fluid-17', className)} {...props}>
				<Container>{children}</Container>
			</section>
		)
	},
)
Section.displayName = 'Section'

export { Section }
